<!-- 中期评审记录表 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 30.33">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="21.74" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="21.74" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="23.52" y1="16.06" x2="23.52" y2="23.37" />
        <rect
          class="cls-3"
          x="20.14"
          y="18"
          width="6.76"
          height="2.61"
          rx="0.8"
        />
        <path
          class="cls-4"
          d="M15.67,9.43a4.8,4.8,0,0,1-4.64-5A4.87,4.87,0,0,1,16.27,0a5,5,0,0,1,3.91,2.23.33.33,0,0,1-.22.49,6.07,6.07,0,0,0-1.22.43.32.32,0,0,1-.41-.1,3,3,0,0,0-3.85-.74,2.71,2.71,0,0,0-1,3.82,2.9,2.9,0,0,0,1.62,1.23.61.61,0,0,1,.44.6,5,5,0,0,0,.15,1.45ZM7.08,19.84a1,1,0,0,1-1-1,9.65,9.65,0,0,1,9.4-9.43.28.28,0,0,1,.26.19A5.16,5.16,0,0,0,16.32,11a.25.25,0,0,1-.22.39,7.75,7.75,0,0,0-8,6.92c0,.2,0,.4,0,.59a1,1,0,0,1-1,1ZM21.37,5.36a2.86,2.86,0,0,0-2.93,2.79,2.87,2.87,0,0,0,2.93,2.79h0a2.87,2.87,0,0,0,2.92-2.79A2.85,2.85,0,0,0,21.37,5.36ZM12.48,23.27a1,1,0,0,1-1-1,9.68,9.68,0,0,1,9.9-9.44,4.86,4.86,0,0,1-5.05-4.63,4.83,4.83,0,0,1,4.86-4.81h.19a4.83,4.83,0,0,1,4.94,4.72,4.84,4.84,0,0,1-4.94,4.72,10.18,10.18,0,0,1,4.21.9,0,0,0,0,1,0,.06A6.52,6.52,0,0,0,23,15a7.88,7.88,0,0,0-9.3,5.87,7.47,7.47,0,0,0-.16,1.49,1,1,0,0,1-1,1Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 30.17">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="21.57" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="21.57" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="22.75" y1="16.06" x2="22.75" y2="23.37" />
        <rect
          class="cls-3"
          x="19.37"
          y="18"
          width="6.76"
          height="2.61"
          rx="0.8"
        />
        <path
          class="cls-4"
          d="M14.91,9.43a4.79,4.79,0,0,1-4.64-5A4.86,4.86,0,0,1,15.51,0a5,5,0,0,1,3.91,2.23.33.33,0,0,1-.23.49A6.55,6.55,0,0,0,18,3.16a.33.33,0,0,1-.41-.1,3,3,0,0,0-3.85-.74,2.72,2.72,0,0,0-1,3.82,2.9,2.9,0,0,0,1.62,1.23.61.61,0,0,1,.44.6,5.42,5.42,0,0,0,.16,1.45ZM6.31,19.84a1,1,0,0,1-1-1,9.65,9.65,0,0,1,9.4-9.43.27.27,0,0,1,.26.19,5.55,5.55,0,0,0,.6,1.34.25.25,0,0,1-.23.39,7.76,7.76,0,0,0-8,6.92c0,.2,0,.4,0,.59a1,1,0,0,1-1,1ZM20.6,5.36a2.85,2.85,0,0,0-2.92,2.79,2.87,2.87,0,0,0,2.92,2.79h0a2.87,2.87,0,0,0,2.93-2.79A2.86,2.86,0,0,0,20.6,5.36ZM11.71,23.27a1,1,0,0,1-1-1,9.69,9.69,0,0,1,9.9-9.44,4.85,4.85,0,0,1-5-4.63,4.83,4.83,0,0,1,4.85-4.81h.19a4.84,4.84,0,0,1,4.95,4.72,4.85,4.85,0,0,1-4.95,4.72,10.19,10.19,0,0,1,4.22.9,0,0,0,0,1,0,.06A6.56,6.56,0,0,0,22.18,15a7.87,7.87,0,0,0-9.29,5.87,6.8,6.8,0,0,0-.16,1.49,1,1,0,0,1-1,1Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 30.33">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="21.74" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="21.74" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="23.52" y1="16.06" x2="23.52" y2="23.37" />
        <rect
          class="cls-3"
          x="20.14"
          y="18"
          width="6.76"
          height="2.61"
          rx="0.8"
        />
        <path
          class="cls-4"
          d="M15.67,9.43a4.8,4.8,0,0,1-4.64-5A4.87,4.87,0,0,1,16.27,0a5,5,0,0,1,3.91,2.23.33.33,0,0,1-.22.49,6.07,6.07,0,0,0-1.22.43.32.32,0,0,1-.41-.1,3,3,0,0,0-3.85-.74,2.71,2.71,0,0,0-1,3.82,2.9,2.9,0,0,0,1.62,1.23.61.61,0,0,1,.44.6,5,5,0,0,0,.15,1.45ZM7.08,19.84a1,1,0,0,1-1-1,9.65,9.65,0,0,1,9.4-9.43.28.28,0,0,1,.26.19A5.16,5.16,0,0,0,16.32,11a.25.25,0,0,1-.22.39,7.75,7.75,0,0,0-8,6.92c0,.2,0,.4,0,.59a1,1,0,0,1-1,1ZM21.37,5.36a2.86,2.86,0,0,0-2.93,2.79,2.87,2.87,0,0,0,2.93,2.79h0a2.87,2.87,0,0,0,2.92-2.79A2.85,2.85,0,0,0,21.37,5.36ZM12.48,23.27a1,1,0,0,1-1-1,9.68,9.68,0,0,1,9.9-9.44,4.86,4.86,0,0,1-5.05-4.63,4.83,4.83,0,0,1,4.86-4.81h.19a4.83,4.83,0,0,1,4.94,4.72,4.84,4.84,0,0,1-4.94,4.72,10.18,10.18,0,0,1,4.21.9,0,0,0,0,1,0,.06A6.52,6.52,0,0,0,23,15a7.88,7.88,0,0,0-9.3,5.87,7.47,7.47,0,0,0-.16,1.49,1,1,0,0,1-1,1Z"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }
    .cls-4 {
      fill: #999;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #27aa8e;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.8px;
    }
    .cls-4 {
      fill: #27aa8e;
    }
  }
</style>
